import z from "zod";

import { patch } from "./Patch";

/**
 * Enqueues a transaction to be processed by the page storage collab server
 */
export const enqueueTransactionEvent = z.object({
	type: z.literal("enqueueTransaction"),
	transactionId: z.optional(z.string()),
	lastVersionSeen: z.number(),
	patches: z.array(patch),
});

/**
 * Enqueues a transaction to be processed by the page storage collab server.
 */
export type EnqueueTransactionEvent = z.infer<typeof enqueueTransactionEvent>;
